module.exports = __webpack_public_path__ + "img/giao-vien.637e9efa.png";